<template>
  <span>
    <q-icon
      :name="tenant ? 'edit' : 'add'"
      size="16px"
      color="primary"
    />
    <slot />
    <q-popup-edit
      v-model="tenantPayload"
      buttons
      @show="show"
      @save="save"
    >
      <q-input
        v-model="tenantPayload.first_name"
        float-label="First name"
        autofocus
      />
      <q-input
        v-model="tenantPayload.last_name"
        float-label="Last name"
      />
      <q-input
        v-model="tenantPayload.email"
        float-label="Email"
      />
      <q-input
        v-model="tenantPayload.phone_number"
        float-label="Phone"
      />
    </q-popup-edit>
  </span>
</template>

<script>
export default {
  name: 'EditInspectionTenant',
  props: {
    tenant: {
      type: Object,
    },
  },
  data() {
    return {
      tenantPayload: this.tenant || { ...defaultTenant },
    };
  },
  methods: {
    show() {
      this.tenantPayload = this.tenant || { ...defaultTenant };
    },
    save(newTenant) {
      this.$emit('save', newTenant);
      this.tenantPayload = { ...this.tenantPayload, ...newTenant };
    },
  },
};
const defaultTenant = {
  first_name: null,
  last_name: null,
  phone_number: null,
  email: null,
};
</script>
